import { render, staticRenderFns } from "./shareDetail.vue?vue&type=template&id=608a9be3&"
import script from "./shareDetail.vue?vue&type=script&lang=js&"
export * from "./shareDetail.vue?vue&type=script&lang=js&"
import style0 from "./shareDetail.vue?vue&type=style&index=0&id=608a9be3&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports